import React from "react";

import { useState } from "react";
import Input from "../../controls/Input";

interface Make {
  id?: number;
  make: string;
  model: string;
  type: string;
  serial: string;
}

interface AddServiceToOrderModalProps {
  make: Make;
  isEdit: Boolean;
  confirmAction: (values: Make) => void;
  setOpen: (value: { open: boolean }) => void;
}

export default function AddServiceToOrderModal({
  make,
  isEdit,
  confirmAction,
  setOpen,
}: AddServiceToOrderModalProps) {
  const [values, setValues] = useState<Make>(make);

  return (
    <div className="justify-between">
      <div>
        <div className="flex items-center justify-between flex-wrap sm:flex-nowrap">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {isEdit ? `Editing ${make.make}` : "Add new make to WO"}
            </h3>
          </div>
        </div>

        <div className="py-1 gap-4 bg-white sm:rounded-xl">
          <div className="grid grid-cols-2 gap-4 w-full">
            <Input
              label="Make"
              name="make"
              onChange={(e) => setValues({ ...values, make: e.target.value })}
              value={values.make}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              label="Model"
              name="model"
              onChange={(e) => setValues({ ...values, model: e.target.value })}
              value={values.model}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              label="Type"
              name="type"
              onChange={(e) => setValues({ ...values, type: e.target.value })}
              value={values.type}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              label="Serial"
              name="serial"
              onChange={(e) => setValues({ ...values, serial: e.target.value })}
              value={values.serial}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>

          <div className="sm:flex-no-wrap my-auto flex items-center">
            <button
              onClick={() => {
                confirmAction(values);
                setOpen({ open: false });
              }}
              className="inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center"
            >
              OK
            </button>
            <button
              onClick={() => setOpen({ open: false })}
              className="ml-2 inline-flex justify-center mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
